import { render, staticRenderFns } from "./Multiselect.vue?vue&type=template&id=088cb54e&"
import script from "./Multiselect.vue?vue&type=script&lang=ts&"
export * from "./Multiselect.vue?vue&type=script&lang=ts&"
import style0 from "./Multiselect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports